"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { benefits } from "@/lib/data/homepage";

/**
 * Benefits — Editorial pull-quote style. 3 large benefits with
 * oversized typography, 3 smaller benefits in compact cards.
 */
export function Benefits() {
  const featured = benefits.slice(0, 3);
  const compact = benefits.slice(3);
  return (
    <section id="benefits" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-cyan)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-cyan)]" />
            Benefits
          </span>
          <h2 className="mt-6">
            Why Perception X2 Delivers
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-5">
          {featured.map((b, i) => {
            const accents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)"];
            return (
              <Reveal key={b.title} delay={i * 100}>
                <div
                  className="rounded-3xl glass p-7 h-full relative overflow-hidden card-glow"
                  style={{ ["--glow" as string]: accents[i] }}
                >
                  <Icon name={b.icon} className="h-7 w-7 mb-4" style={{ color: accents[i] }} />
                  <h3 className="mb-3">{b.title}</h3>
                  <p className="text-body-sm leading-relaxed text-[rgb(var(--fg-muted))]">
                    {b.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {compact.length > 0 && (
          <div className="mt-5 grid sm:grid-cols-3 gap-4">
            {compact.map((b, i) => {
              const accents = ["var(--color-emerald)", "var(--color-amber)", "var(--color-coral)"];
              return (
                <Reveal key={b.title} delay={i * 80}>
                  <div
                    className="rounded-2xl glass p-5 h-full flex items-start gap-3"
                  >
                    <span
                      className="grid place-items-center h-9 w-9 rounded-lg shrink-0"
                      style={{
                        background: `color-mix(in oklch, ${accents[i]} 18%, transparent)`,
                        boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accents[i]} 35%, transparent)`,
                      }}
                    >
                      <Icon name={b.icon} className="h-4 w-4" style={{ color: accents[i] }} />
                    </span>
                    <div>
                      <h3>{b.title}</h3>
                      <p className="mt-1.5 text-caption leading-relaxed text-[rgb(var(--fg-muted))]">
                        {b.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        )}
      </Container>
    </section>
  );
}
